import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('window');

export const DEFAULT_SPINNER_DELAY_MS = 250;

export const RouteFragment = {
  Admin: 'admin',
  Administrative: 'administrative',
  CompanyDocuments: 'company-documents',
  DataAnalytics: 'data-analytics',
  EmploymentManagement: 'employment-management',
  Finance: 'finance',
  FinanceManagement: 'finance-management',
  Hr: 'hr',
  It: 'it',
  Legal: 'legal',
  Main: 'main',
  Marketing: 'marketing',
  NoRole: 'norole',
  OperationsServices: 'operations-services',
  Organization: 'org',
  Overview: 'overview',
  Payroll: 'payroll',
  People: 'people',
  Roles: 'roles',
  SignIn: 'signin',
  StrategyBoard: 'strategy-board',
} as const;

export const RouteParam = {
  OrganizationTenantKey: 'orgTenantKey',
  PayrollId: 'payrollId',
} as const;
